import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import {
    ANIMATION_BIGGER,
    ANIMATION_SMALLER,
    conditionalScaleAnimation
} from 'libs/styles/animations';
import { useContext } from 'react';
import { CtxDetail } from 'session/ctxDetail';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const QuickSave = (props: Props): JSX.Element => {
    const ctxDetail = useContext(CtxDetail);

    return (
        <motion.div {...conditionalScaleAnimation(true, ANIMATION_BIGGER, ANIMATION_SMALLER)}>
            <S_QuickSave className={props.className}>
                <S_Minimize
                    icon={['fal', 'minus']}
                    onClick={() => {
                        ctxDetail.setUpdatingIndex(-2);
                    }}
                />
            </S_QuickSave>
        </motion.div>
    );
};

const S_QuickSave = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const S_Minimize = styled(FontAwesomeIcon)`
    color: white;
    cursor: pointer;
    font-size: 20px;
    margin: 2px 0 0 0;
`;
